import {
	gridGutter,
	fontSize20,
	fontSize18,
	fontSize12
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import { grayFont } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

export const defaultStyle = `
	position: absolute;
	width: 100%;
	height: 100%;
	display: block;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(63, 63, 63, 0.6);
	z-index: 99999;

	&.enter {
		opacity: 0;

		&-active {
			opacity: 1;
			transition: all 300ms ease-in;
			transform: translateX(0px);
		}
	}

	&.exit {
		opacity: 1;

		&-active {
			opacity: 0;
			transition: all 300ms ease-in;
		}
	}
`;

export const contentStyle = `
	position: absolute;
	margin: auto;
	bottom: 0;
	left: 0;
	background: white;
	padding: ${gridGutter}px;
	border-radius: 12px 12px 0 0;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	.close-button {
		text-align: right;
		margin-top: -15px;
		margin-right: -15px;
	}
`;

export const titleStyle = `
	font-size: ${fontSize20};
	font-weight: bold;
	color: #8f8f8f;
`;

export const descriptionStyle = `
	color: ${grayFont};
`;

export const buttonStyle = `
	padding: ${gridGutter}px 0 0;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
	align-items: flex-start;

	button {
		font-size: ${fontSize18};
		font-weight: bold;
		@media (max-width: 415px) {
			font-size: ${fontSize12};
		}
	}
`;
